import React from 'react';
import styles from './styles.module.css';

const TabItem = ({ title, selected, id, ...rest }) => {
  return (
    <li className={`${styles.menuItem} ${selected && styles.menuItemSelected}`} {...rest} data-testid={id}>{title}</li>
  )
}

export default TabItem;
